import Types from "./Types";

export const getAllSubjectsRequest = (body) => ({
  type: Types.GET_PUBLIC_SUBJECTS_REQUEST,
  payload: body,
});

export const getAllSubjectsSuccess = (data) => ({
  type: Types.GET_PUBLIC_SUBJECTS_SUCCESS,
  payload: data,
});

export const getAllSubjectsFail = () => ({
  type: Types.GET_PUBLIC_SUBJECTS_FAIL,
});
export const getAllTeachersRequest = (body) => ({
  type: Types.GET_PUBLIC_TEACHERS_REQUEST,
  payload: body,
});

export const getAllTeachersSuccess = (data) => ({
  type: Types.GET_PUBLIC_TEACHERS_SUCCESS,
  payload: data,
});

export const getAllTeachersFail = () => ({
  type: Types.GET_PUBLIC_TEACHERS_FAIL,
});

export const getTeacherRequest = (body) => ({
  type: Types.GET_PUBLIC_TEACHER_REQUEST,
  payload: body,
});

export const getTeacherSuccess = (data) => ({
  type: Types.GET_PUBLIC_TEACHER_SUCCESS,
  payload: data,
});

export const getTeacherFail = () => ({
  type: Types.GET_PUBLIC_TEACHER_FAIL,
});

export const getTeacherCoursesRequest = (id, userId) => ({
  type: Types.GET_PUBLIC_TEACHER_COURSES_REQUEST,
  payload: { id, userId },
});

export const getTeacherCoursesSuccess = (data) => ({
  type: Types.GET_PUBLIC_TEACHER_COURSES_SUCCESS,
  payload: data,
});

export const getTeacherCoursesFail = () => ({
  type: Types.GET_PUBLIC_TEACHER_COURSES_FAIL,
});
//LOADING
export const publicLoading = (isLoading) => ({
  type: Types.PUBLIC_LOADING,
  payload: isLoading,
});

// Create Chapter
